import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4a507e79"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-flex tw-justify-between tw-items-center tw-w-full tw-flex-wrap" }
const _hoisted_2 = { class: "tw-text-[#231F20] tw-text-[14px] tw-not-italic tw-font-medium tw-leading-[145%] question tw-w-[241px]" }
const _hoisted_3 = {
  key: 0,
  class: "tw-text-[red]"
}
const _hoisted_4 = { class: "tw-flex tw-w-[50%] tw-items-center tw-gap-[60px] tw-px-0 tw-py-[18px] answer" }
const _hoisted_5 = { class: "tw-flex" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "md:tw-flex md:tw-w-[50%]" }, null, -1))
const _hoisted_7 = {
  key: 0,
  class: "tw-flex md:tw-w-[50%] tw-w-[100%] invalid"
}

import { assessmentAnswerType1State } from "@/utils/constants";
import BaseCheckbox from "../common/form/baseCheckbox.vue";
import { onMounted, ref, watch } from "vue";
import { getComponentUiText } from "@/utils/utilities";


export default /*#__PURE__*/_defineComponent({
  __name: 'wizardRadioQuestion',
  props: {
  title: {
    type: String,
    required: true,
  },
  required: {
    type: Boolean,
    default: false,
  },
  answer: {
    type: [Number, String],
    default: null,
  },
  disabled: {
    type: Boolean,
    default: true,
  },
  textLeft: {
    type: String,
    default: "",
  },
  textRight: {
    type: String,
    default: "",
  },
  notYesNo: {
    type: Boolean,
    default: false,
  },

  mesageError: {
    type: Boolean,
    default: false,
  },

  isApiError: {
    type: Boolean,
    required: false,
    default: false,
  },
},
  emits: ["onUpdate", "update:answer"],
  setup(__props, { emit: emits }) {

const props = __props;



const state: any = ref(props.answer);



const handleState = (value: number | string) => {
  if (props.answer !== null && !state.value && !isMounted) return;
  state.value = value;
  emits("onUpdate", value);
  emits("update:answer", value);
};

watch(
  () => props.answer,
  (newValue, oldValue) => {
    // if (newValue) {
    state.value = newValue;
    handleState(newValue);
    // }
  },
  { deep: true },
);
let isMounted = false;
onMounted(() => {
  setTimeout(() => {
    isMounted = true;
  }, 500);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", null, _toDisplayString(__props.title), 1),
        (__props.required)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, " *"))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(BaseCheckbox, {
          text: 
          __props.textLeft
            ? __props.textLeft
            : _unref(getComponentUiText)(
                'app-menu-submenu-home-setup-wizard-radio-button-title-yes-1',
              )
        ,
          color: 
          __props.isApiError && state.value === _unref(assessmentAnswerType1State).yes
            ? '#F7553C'
            : '#387DFF'
        ,
          "un-selected-color": 
          __props.isApiError && state.value === _unref(assessmentAnswerType1State).yes
            ? '#F7553C'
            : '#DBDBDB'
        ,
          ticked: state.value === _unref(assessmentAnswerType1State).yes,
          "not-yes-no": __props.notYesNo,
          disabled: !__props.disabled ? '' : __props.answer,
          "text-left": __props.textLeft,
          "text-style": 
          __props.isApiError && state.value === _unref(assessmentAnswerType1State).yes
            ? 'tw-text-[#F7553C]'
            : ''
        ,
          "data-cy": "yes",
          onSelected: _cache[0] || (_cache[0] = () => handleState(_unref(assessmentAnswerType1State).yes)),
          onUnselected: _cache[1] || (_cache[1] = () => handleState(_unref(assessmentAnswerType1State).unselected))
        }, null, 8, ["text", "color", "un-selected-color", "ticked", "not-yes-no", "disabled", "text-left", "text-style"]),
        _createVNode(BaseCheckbox, {
          text: 
          __props.textRight
            ? __props.textRight
            : _unref(getComponentUiText)(
                'app-menu-submenu-home-setup-wizard-radio-button-title-no-1',
              )
        ,
          color: 
          __props.isApiError && state.value === _unref(assessmentAnswerType1State).no
            ? '#F7553C'
            : '#387DFF'
        ,
          "un-selected-color": 
          __props.isApiError && state.value === _unref(assessmentAnswerType1State).no
            ? '#F7553C'
            : '#DBDBDB'
        ,
          ticked: state.value === _unref(assessmentAnswerType1State).no,
          disabled: !__props.disabled ? '' : __props.answer,
          "not-yes-no": __props.notYesNo,
          "text-left": __props.textLeft,
          "text-style": 
          __props.isApiError && state.value === _unref(assessmentAnswerType1State).no
            ? 'tw-text-[#F7553C]'
            : ''
        ,
          "data-cy": "no",
          onSelected: _cache[2] || (_cache[2] = () => handleState(_unref(assessmentAnswerType1State).no)),
          onUnselected: _cache[3] || (_cache[3] = () => handleState(_unref(assessmentAnswerType1State).unselected))
        }, null, 8, ["text", "color", "un-selected-color", "ticked", "disabled", "not-yes-no", "text-left", "text-style"])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      (__props.mesageError)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_unref(getComponentUiText)("app-setting-org-detail-required-fields-1")), 1))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})